import { Schema } from "effect";

export const shimmerSwapMs = 220;
export const ShimmerSnapshot = Schema.Struct({ active: Schema.Boolean, run: Schema.Boolean });
export type ShimmerSnapshot = typeof ShimmerSnapshot.Type;
